
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AllClientTermsAndConditionsResource,
  ClientTermsAndConditionsTarget,
  UploadClientTermsAndConditionsDocumentForWholeOrganizationResponse,
} from '../models';
import {
    AllClientTermsAndConditionsResourceFromJSON,
    AllClientTermsAndConditionsResourceToJSON,
    ClientTermsAndConditionsTargetFromJSON,
    ClientTermsAndConditionsTargetToJSON,
    UploadClientTermsAndConditionsDocumentForWholeOrganizationResponseFromJSON,
    UploadClientTermsAndConditionsDocumentForWholeOrganizationResponseToJSON,
} from '../models';

export interface ArchiveDocumentRequest {
    legalEntityId: string;
    target: ClientTermsAndConditionsTarget;
}

export interface FindAllClientTermsAndConditionsRequest {
    legalEntityId: string;
}

export interface UploadClientTermsAndConditionsDocumentRequest {
    legalEntityId: string;
    target: ClientTermsAndConditionsTarget;
    file: Blob;
}

export interface UploadClientTermsAndConditionsDocumentForWholeOrganizationRequest {
    organizationId: string;
    target: ClientTermsAndConditionsTarget;
    file: Blob;
}

/**
 * 
 */
export class ClientTermsAndConditionsApi extends runtime.BaseAPI {

    /**
     * Archive client terms and conditions document of legal entity
          */
    async archiveDocumentRaw(requestParameters: ArchiveDocumentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling archiveDocument().'
            );
        }

        if (requestParameters['target'] == null) {
            throw new runtime.RequiredError(
                'target',
                'Required parameter "target" was null or undefined when calling archiveDocument().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['target'] != null) {
            queryParameters['target'] = requestParameters['target'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/client-settings/api/legal-entities/{legalEntityId}/terms-and-conditions/archive`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Archive client terms and conditions document of legal entity
          */
    async archiveDocument(requestParameters: ArchiveDocumentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.archiveDocumentRaw(requestParameters, initOverrides);
    }

    /**
     * Find all client terms and conditions documents
          */
    async findAllClientTermsAndConditionsRaw(requestParameters: FindAllClientTermsAndConditionsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AllClientTermsAndConditionsResource>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling findAllClientTermsAndConditions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AllClientTermsAndConditionsResource>({
            path: `/client-settings/api/legal-entities/{legalEntityId}/terms-and-conditions`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AllClientTermsAndConditionsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Find all client terms and conditions documents
          */
    async findAllClientTermsAndConditions(requestParameters: FindAllClientTermsAndConditionsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AllClientTermsAndConditionsResource> {
        const response = await this.findAllClientTermsAndConditionsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Upload client terms and conditions document
          */
    async uploadClientTermsAndConditionsDocumentRaw(requestParameters: UploadClientTermsAndConditionsDocumentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling uploadClientTermsAndConditionsDocument().'
            );
        }

        if (requestParameters['target'] == null) {
            throw new runtime.RequiredError(
                'target',
                'Required parameter "target" was null or undefined when calling uploadClientTermsAndConditionsDocument().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadClientTermsAndConditionsDocument().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['target'] != null) {
            queryParameters['target'] = requestParameters['target'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request<void>({
            path: `/client-settings/api/legal-entities/{legalEntityId}/terms-and-conditions`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return response;
    }

    /**
     * Upload client terms and conditions document
          */
    async uploadClientTermsAndConditionsDocument(requestParameters: UploadClientTermsAndConditionsDocumentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadClientTermsAndConditionsDocumentRaw(requestParameters, initOverrides);
    }

    /**
     * Upload same client terms and conditions document for all legal entities of given organization
          */
    async uploadClientTermsAndConditionsDocumentForWholeOrganizationRaw(requestParameters: UploadClientTermsAndConditionsDocumentForWholeOrganizationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<UploadClientTermsAndConditionsDocumentForWholeOrganizationResponse>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling uploadClientTermsAndConditionsDocumentForWholeOrganization().'
            );
        }

        if (requestParameters['target'] == null) {
            throw new runtime.RequiredError(
                'target',
                'Required parameter "target" was null or undefined when calling uploadClientTermsAndConditionsDocumentForWholeOrganization().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadClientTermsAndConditionsDocumentForWholeOrganization().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['target'] != null) {
            queryParameters['target'] = requestParameters['target'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request<UploadClientTermsAndConditionsDocumentForWholeOrganizationResponse>({
            path: `/client-settings/api/admin/organizations/{organizationId}/terms-and-conditions`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=UploadClientTermsAndConditionsDocumentForWholeOrganizationResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Upload same client terms and conditions document for all legal entities of given organization
          */
    async uploadClientTermsAndConditionsDocumentForWholeOrganization(requestParameters: UploadClientTermsAndConditionsDocumentForWholeOrganizationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<UploadClientTermsAndConditionsDocumentForWholeOrganizationResponse> {
        const response = await this.uploadClientTermsAndConditionsDocumentForWholeOrganizationRaw(requestParameters, initOverrides);
        return response._data;
    }

}
